<template>
	<vs-prompt
        class="text-popup"
				:active.sync="activePrompt"
				:buttons-hidden="true"
				button-cancel="filled"
        title=""
				@keydown.esc="closePopup"
        @close="fileName = null"
	>
		<div class="flex justify-center align-center">
			<div v-html="message"></div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "FullTextPopup",
	props: {
		active: {
			required: true,
			type: Boolean
		},
		message: {
			type: String,
			default: ''
		}
	},
	created() {
		document.addEventListener('keyup', this.closePopup);
	},
	destroyed() {
		document.removeEventListener('keyup', this.closePopup);
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				this.$emit("update:message", '')
			}
		},
	},
    methods: {
			closePopup(e) {
				if (e.keyCode === 27) {
					this.activePrompt = false
				}
			}
    }
};
</script>
<style lang="scss">
.text-popup {
    z-index: 999999 !important;
		.vs-dialog {
			max-width: max-content !important;
			&-text {
				max-height: 90vh;
				overflow-y: auto;
			}
		}
}
</style>